/**
 * @generated SignedSource<<7f697c28e3516654d44edcb69c6d7cda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedShoppingButton_item$data = {
  readonly defaultSkuId: string;
  readonly serviceId: string;
  readonly " $fragmentType": "PdpSharedShoppingButton_item";
};
export type PdpSharedShoppingButton_item$key = {
  readonly " $data"?: PdpSharedShoppingButton_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedShoppingButton_item">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShoppingButton_item",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "serviceId",
        "storageKey": null
      },
      "action": "THROW",
      "path": "serviceId"
    },
    {
      "kind": "RequiredField",
      "field": {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "defaultSkuId",
        "storageKey": null
      },
      "action": "THROW",
      "path": "defaultSkuId"
    }
  ],
  "type": "Item",
  "abstractKey": null
};

(node as any).hash = "fa23daf3a814e3a9f52dd0a65b23d8e5";

export default node;
